// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__LG19l","modal":"styles_modal__1XamP"};